import React from 'react'
import { Box, BoxProps, useTheme, SxProps, Theme } from '@mui/material'

const BannerBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  const theme = useTheme()

  const baseSx: SxProps<Theme> = {
    width: '100%',
    backgroundColor: theme.palette.imageUploadBackground?.main,
    p: 1.25,
    borderRadius: 1,
    border: `1px solid ${theme.palette.customBackground?.divider}`,
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
  }

  // allow consumer sx to override or extend
  const mergedSx: SxProps<Theme> = Array.isArray(sx)
    ? [baseSx, ...sx]
    : [baseSx, sx]

  return (
    <Box sx={mergedSx} {...rest}>
      {children}
    </Box>
  )
}

export default BannerBox
